module.exports = __webpack_public_path__ + "static/media/knImg.1f217646.png";